'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * Item id
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * Item title
   */
  title: _propTypes2.default.string,
  /**
   * Show/hide item's content
   */
  expanded: _propTypes2.default.bool,
  /**
   * Removes content paddings
   */
  contentBlank: _propTypes2.default.bool,
  /**
   * Adds additional content slot to the item's header
   */
  headerSlot: _propTypes2.default.node,
  /**
   * Function to be called on title click
   */
  onToggleExpanded: _propTypes2.default.func,
  /**
   * @ignore
   */
  // eslint-disable-next-line react/require-default-props
  theme: _propTypes2.default.object
};

var defaultProps = {
  id: null,
  title: '',
  expanded: false,
  contentBlank: false,
  onToggleExpanded: _reactackleCore.noop,
  headerSlot: null
};

var AccordionItem = function (_Component) {
  _inherits(AccordionItem, _Component);

  function AccordionItem(props) {
    _classCallCheck(this, AccordionItem);

    var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props));

    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(AccordionItem, [{
    key: '_handleClick',
    value: function _handleClick() {
      this.props.onToggleExpanded({ id: this.props.id });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expanded = _props.expanded,
          contentBlank = _props.contentBlank;


      var title = this.props.title && _react2.default.createElement(
        _styles.TitleStyled,
        { expanded: expanded },
        this.props.title
      );

      var styleKey = expanded ? 'expanded' : 'collapsed';

      return [_react2.default.createElement(
        _styles.HeadingStyled,
        { key: 'heading', role: 'heading' },
        _react2.default.createElement(
          _styles.TitleBoxStyled,
          {
            expanded: expanded,
            onClick: this._handleClick,
            role: 'button',
            'aria-expanded': expanded,
            'aria-controls': this.props.id,
            id: 'labelfor' + this.props.id
          },
          _react2.default.createElement(
            _styles.TitleContentStyled,
            null,
            title,
            this.props.headerSlot
          ),
          _react2.default.createElement(
            _styles.IconExpandWrapperStyled,
            null,
            _react2.default.createElement(
              _styles.IconWrapperStyled,
              { expanded: expanded },
              this.props.theme.reactackle.components.accordion.item.expandIcon[styleKey].iconElement
            )
          )
        )
      ), _react2.default.createElement(
        _styles.ContentStyled,
        {
          key: 'content',
          expanded: expanded,
          contentBlank: contentBlank,
          id: this.props.id,
          role: 'region',
          'aria-labelledby': 'labelfor' + this.props.id
        },
        this.props.children
      )];
    }
  }]);

  return AccordionItem;
}(_react.Component);

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
AccordionItem.displayName = 'AccordionItem';

exports.default = (0, _reactackleCore.withTheme)(AccordionItem);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-accordion/dist/AccordionItem/AccordionItem.js
// module id = 205
// module chunks = 0